import { alpha, Box, SxProps, useTheme } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Reorder } from "@mui/icons-material";

interface SortableDndRowProps {
    id: string;
    children: React.ReactNode;
    sx?: SxProps;
}

export function SortableDndRow({ id, children, sx }: SortableDndRowProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });
    const theme = useTheme();

    return (
        <Box
            ref={setNodeRef}
            mb={1.5}
            sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                cursor: "grab",
                backgroundColor: "transparent",
                boxShadow: isDragging ? theme.shadows[3] : undefined,
                borderRadius: 2,
                background: isDragging ? alpha(theme.palette.primary.main, 0.1) : undefined,
                transform: CSS.Transform.toString(transform),
                transition,
                zIndex: isDragging ? 999 : undefined,
                position: "relative",
                ...sx,
            }}
            {...attributes}
        >
            <Box
                mr={1}
                sx={{ cursor: "grab", display: "flex", alignItems: "center" }}
                {...listeners}
            >
                <Reorder color="secondary" />
            </Box>
            {children}
        </Box>
    );
} 